export var DevicesBreakpointsEnumeration;
(function (DevicesBreakpointsEnumeration) {
    DevicesBreakpointsEnumeration["MOBILE"] = "MOBILE";
    DevicesBreakpointsEnumeration["TABLET"] = "TABLET";
    DevicesBreakpointsEnumeration["DESKTOP"] = "DESKTOP";
    DevicesBreakpointsEnumeration["LARGE_DESKTOP"] = "LARGE_DESKTOP";
})(DevicesBreakpointsEnumeration || (DevicesBreakpointsEnumeration = {}));
//# sourceMappingURL=devices-breakpoints.enumeration.js.map